import { render, staticRenderFns } from "./CellTextIcon.vue?vue&type=template&id=23b883e4"
import script from "./CellTextIcon.vue?vue&type=script&lang=js"
export * from "./CellTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports